import { observer } from 'mobx-react-lite'
import { useMemo } from 'react'
import { Table } from 'shared/ui/TableNew'
import { type ConversationsComparisonTableStore } from 'pages/analytics/pages/conversations/store/conversationsAnalyticsPageStore'
import { getColumns } from './getColumns'

interface IConversationsComparisonTableProps {
  store: ConversationsComparisonTableStore
}

export const ConversationsComparisonTable = observer(
  ({ store }: IConversationsComparisonTableProps) => {
    const { tableStore, comparisonRows, breakdownFilterType } = store

    const columns = useMemo(() => getColumns(breakdownFilterType), [breakdownFilterType])

    return (
      <Table
        ariaLabel={'ConversationsComparisonTable'}
        store={tableStore}
        columns={columns}
        rows={comparisonRows}
        hidePagination={true}
        emptyStateProps={{
          text: 'No comparison data found',
          noIcon: true,
        }}
        scrollbarProps={{
          autoHeight: true,
          height: 'auto',
          autoHeightMax: 600,
        }}
      />
    )
  }
)
